import { Link } from 'react-router-dom';
import { useState } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const BlogPage = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');

  const categories = [
    'All',
    'Digital Marketing Tips',
    'How To\'s',
    'Checklists',
    'Free Resources',
    'Free Marketing Tools',
    'Social Media Content Marketing Tips',
    'Local SEO',
    'Google My Business Management',
    'Website Marketing',
    'Website Management',
    'Customer Care Tips',
    'Startup Budgets',
    'On a Shoestring'
  ];

  const blogPosts = [
    {
      id: 1,
      title: '10 Essential Digital Marketing Tips for Small Businesses in 2024',
      excerpt: 'Discover the most effective digital marketing strategies that will help your small business thrive in 2024.',
      category: 'Digital Marketing Tips',
      date: 'March 15, 2024',
      readTime: '8 min read',
      image: 'https://public.readdy.ai/ai/img_res/7dec0718dab78d7d3d0eb2f445b0d429.jpg',
      link: '/blog/articles/digital-marketing-tips-2024'
    },
    {
      id: 2,
      title: 'How to Set Up Your Google My Business Profile for Maximum Visibility',
      excerpt: 'A step-by-step guide to optimizing your Google My Business listing to attract more local customers.',
      category: 'Google My Business Management',
      date: 'March 12, 2024',
      readTime: '10 min read',
      image: 'https://readdy.ai/api/search-image?query=google%20my%20business%20profile%20setup%20on%20computer%20screen%20with%20local%20business%20optimization&width=800&height=500&seq=blogpost2&orientation=landscape',
      link: '/blog/articles/google-my-business-setup'
    },
    {
      id: 3,
      title: 'The Ultimate Social Media Content Calendar Checklist',
      excerpt: 'Stay organized and consistent with your social media posting using our comprehensive content calendar checklist.',
      category: 'Checklists',
      date: 'March 8, 2024',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=social%20media%20content%20calendar%20planning%20with%20colorful%20schedule%20and%20post%20ideas&width=800&height=500&seq=blogpost3&orientation=landscape',
      link: '/blog/articles/social-media-content-calendar'
    },
    {
      id: 4,
      title: '15 Free Marketing Tools Every Small Business Should Use in 2024',
      excerpt: 'Save money while growing your business with these powerful free marketing tools and resources.',
      category: 'Free Marketing Tools',
      date: 'March 5, 2024',
      readTime: '12 min read',
      image: 'https://readdy.ai/api/search-image?query=collection%20of%20free%20marketing%20tools%20displayed%20on%20laptop%20screen%20with%20colorful%20app%20icons&width=800&height=500&seq=blogpost4&orientation=landscape',
      link: '/blog/articles/free-marketing-tools'
    },
    {
      id: 5,
      title: 'Complete Local SEO Guide: Dominate Your Local Market in 2024',
      excerpt: 'Learn how to optimize your online presence to rank higher in local search results and attract nearby customers.',
      category: 'Local SEO',
      date: 'March 3, 2024',
      readTime: '15 min read',
      image: 'https://readdy.ai/api/search-image?query=local%20seo%20optimization%20showing%20map%20with%20business%20locations%20and%20search%20rankings&width=800&height=500&seq=blogpost5&orientation=landscape',
      link: '/blog/articles/local-seo-guide'
    },
    {
      id: 6,
      title: 'How to Create a Startup Marketing Budget That Actually Works',
      excerpt: 'Learn how to allocate your startup marketing budget effectively to maximize ROI and accelerate growth.',
      category: 'Startup Budgets',
      date: 'March 1, 2024',
      readTime: '9 min read',
      image: 'https://readdy.ai/api/search-image?query=startup%20budget%20planning%20with%20financial%20charts%20and%20marketing%20allocation%20spreadsheet&width=800&height=500&seq=blogpost6&orientation=landscape',
      link: '/blog/articles/startup-marketing-budget'
    },
    {
      id: 7,
      title: 'Website Management Best Practices for Business Owners',
      excerpt: 'Essential tips for maintaining a secure, fast, and effective website that drives business growth.',
      category: 'Website Management',
      date: 'February 15, 2024',
      readTime: '8 min read',
      image: 'https://readdy.ai/api/search-image?query=website%20management%20dashboard%20showing%20site%20performance%20metrics%2C%20professional%20workspace%2C%20website%20analytics%20and%20monitoring%20tools&width=800&height=500&seq=blogpost7&orientation=landscape',
      link: '/blog/articles/website-management'
    },
    {
      id: 8,
      title: 'Website Marketing: Converting Visitors into Customers',
      excerpt: 'Transform your website into a conversion machine with these proven website marketing strategies.',
      category: 'Website Marketing',
      date: 'February 28, 2024',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=website%20conversion%20optimization%20dashboard%20showing%20visitor%20analytics%2C%20modern%20marketing%20workspace%2C%20colorful%20conversion%20funnel%20graphics&width=800&height=500&seq=blogpost8&orientation=landscape',
      link: '/blog/articles/website-marketing'
    },
    {
      id: 9,
      title: 'Customer Care Excellence: Building Lasting Relationships',
      excerpt: 'Deliver exceptional customer service that turns one-time buyers into loyal brand advocates.',
      category: 'Customer Care Tips',
      date: 'February 25, 2024',
      readTime: '5 min read',
      image: 'https://readdy.ai/api/search-image?query=customer%20service%20representative%20helping%20client%20with%20smile%2C%20professional%20office%20environment%2C%20happy%20customer%20interaction%2C%20bright%20welcoming%20atmosphere&width=800&height=500&seq=blogpost9&orientation=landscape',
      link: '/blog/articles/customer-care-excellence'
    },
    {
      id: 10,
      title: 'Startup Marketing on a Shoestring Budget',
      excerpt: 'Creative, low-cost marketing strategies that help startups compete without breaking the bank.',
      category: 'On a Shoestring',
      date: 'February 22, 2024',
      readTime: '7 min read',
      image: 'https://readdy.ai/api/search-image?query=startup%20entrepreneur%20planning%20budget-friendly%20marketing%20strategy%2C%20small%20office%20workspace%2C%20calculator%20and%20notes%2C%20resourceful%20business%20planning&width=800&height=500&seq=blogpost10&orientation=landscape',
      link: '/blog/articles/shoestring-budget-marketing'
    },
    {
      id: 11,
      title: 'Free Resources: Templates, Guides & Tools for Small Businesses',
      excerpt: 'Access our comprehensive collection of free templates, guides, and tools to streamline your business operations.',
      category: 'Free Resources',
      date: 'February 20, 2024',
      readTime: '4 min read',
      image: 'https://readdy.ai/api/search-image?query=collection%20of%20free%20business%20resources%20and%20templates%20displayed%20on%20screen%2C%20organized%20digital%20library%2C%20professional%20workspace%20with%20documents&width=800&height=500&seq=blogpost11&orientation=landscape',
      link: '/blog/articles/free-resources'
    },
    {
      id: 12,
      title: 'Social Media Content That Drives Engagement',
      excerpt: 'Create social media content that resonates with your audience and drives meaningful engagement.',
      category: 'Social Media Content Marketing Tips',
      date: 'February 18, 2024',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=engaging%20social%20media%20content%20creation%20workspace%2C%20smartphone%20with%20high%20engagement%20posts%2C%20colorful%20social%20media%20interface%2C%20creative%20marketing%20environment&width=800&height=500&seq=blogpost12&orientation=landscape',
      link: '/blog/articles/social-media-engagement'
    }
  ];

  const filteredPosts = selectedCategory === 'All' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-gray-50 to-zinc-50">
      <Header />
      
      <main className="relative z-10">
        {/* Hero Section */}
        <section 
          className="relative min-h-[60vh] flex items-center justify-center bg-cover bg-center"
          style={{
            backgroundImage: `linear-gradient(rgba(15, 23, 42, 0.85), rgba(30, 41, 59, 0.85)), url('https://readdy.ai/api/search-image?query=modern%20blog%20and%20content%20creation%20workspace%20with%20laptop%20and%20notebooks%2C%20professional%20writing%20environment%2C%20bright%20inspiring%20office%20space%2C%20creative%20content%20marketing%20setup&width=1920&height=800&seq=bloghero&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
          <div className="container mx-auto px-6 text-center text-white relative z-10">
            <h1 className="text-5xl md:text-7xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
              Digital Experience Studio Blog
            </h1>
            <p className="text-xl md:text-2xl mb-8 text-gray-200 max-w-3xl mx-auto leading-relaxed">
              Expert insights, practical tips, and free resources to help your small business thrive in the digital world.
            </p>
          </div>
        </section>

        {/* Categories Filter */}
        <section className="py-12 bg-white/80 backdrop-blur-sm sticky top-0 z-30 border-b border-gray-200">
          <div className="container mx-auto px-6">
            <div className="flex items-center gap-3 overflow-x-auto pb-2 scrollbar-hide">
              {categories.map((category) => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-6 py-2 rounded-full font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer ${
                    selectedCategory === category
                      ? 'bg-gradient-to-r from-teal-600 to-emerald-600 text-white shadow-lg'
                      : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
        </section>

        {/* Blog Posts Grid */}
        <section className="py-20">
          <div className="container mx-auto px-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredPosts.map((post) => (
                <article 
                  key={post.id}
                  className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 cursor-pointer"
                >
                  <div className="relative w-full h-56">
                    <img
                      src={post.image}
                      alt={post.title}
                      className="w-full h-full object-cover object-top"
                    />
                    <div className="absolute top-4 left-4">
                      <span className="bg-teal-600 text-white px-4 py-1 rounded-full text-sm font-semibold">
                        {post.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center gap-4 text-sm text-gray-500 mb-3">
                      <span className="flex items-center gap-1">
                        <i className="ri-calendar-line"></i>
                        {post.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <i className="ri-time-line"></i>
                        {post.readTime}
                      </span>
                    </div>
                    <h3 className="text-xl font-bold text-gray-800 mb-3 hover:text-teal-600 transition-colors">
                      {post.title}
                    </h3>
                    <p className="text-gray-600 mb-4 line-clamp-3">
                      {post.excerpt}
                    </p>
                    <Link
                      to={post.link}
                      className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:text-teal-700 transition-colors cursor-pointer"
                    >
                      Read More
                      <i className="ri-arrow-right-line"></i>
                    </Link>
                  </div>
                </article>
              ))}
            </div>

            {filteredPosts.length === 0 && (
              <div className="text-center py-20">
                <div className="w-24 h-24 flex items-center justify-center bg-gray-100 rounded-full mx-auto mb-6">
                  <i className="ri-file-search-line text-5xl text-gray-400"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-3">No posts found</h3>
                <p className="text-gray-600 mb-6">Try selecting a different category</p>
                <button
                  onClick={() => setSelectedCategory('All')}
                  className="bg-teal-600 text-white px-6 py-3 rounded-full font-semibold hover:bg-teal-700 transition-colors cursor-pointer"
                >
                  View All Posts
                </button>
              </div>
            )}
          </div>
        </section>

        {/* Newsletter Subscription CTA */}
        <section className="py-20 bg-gradient-to-r from-teal-600 via-emerald-600 to-green-600">
          <div className="container mx-auto px-6 text-center text-white">
            <div className="max-w-3xl mx-auto">
              <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
                <i className="ri-mail-line text-4xl"></i>
              </div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Never Miss an Update
              </h2>
              <p className="text-xl text-teal-100 mb-8 leading-relaxed">
                Subscribe to our newsletter and get the latest digital marketing tips, free resources, and exclusive insights delivered straight to your inbox.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center max-w-xl mx-auto">
                <input
                  type="email"
                  placeholder="Enter your email address"
                  className="flex-1 px-6 py-4 rounded-full text-gray-800 focus:outline-none focus:ring-4 focus:ring-white/30"
                />
                <button className="bg-white text-teal-600 px-8 py-4 rounded-full font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                  Subscribe Now
                </button>
              </div>
              <p className="text-sm text-teal-100 mt-4">
                Join 5,000+ small business owners getting weekly marketing tips
              </p>
            </div>
          </div>
        </section>

        {/* CTA Section */}
        <section className="py-20">
          <div className="container mx-auto px-6">
            <div className="bg-gradient-to-r from-slate-800 to-gray-800 rounded-3xl shadow-2xl p-12 text-center text-white">
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                Ready to Transform Your Digital Presence?
              </h2>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto mb-8 leading-relaxed">
                Let's discuss how our digital marketing services can help your business grow. Book a free consultation today!
              </p>
              <Link
                to="/consultation"
                className="inline-block bg-gradient-to-r from-teal-500 to-emerald-500 text-white px-8 py-4 rounded-full text-lg font-bold hover:from-teal-600 hover:to-emerald-600 transition-all duration-300 transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
              >
                Book Free Consultation
              </Link>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default BlogPage;